import axios from 'axios';

import API_BASE_URL from './config/api';

let currentUrl = API_BASE_URL;

// REQUISITA A LISTA DE TODAS AS NOTIFICAÇÕES DO SINAN //
export const requestSinanNotesList = async (body, token) => {
	try {
		const { data } = await axios.get(`${currentUrl}/sinan/notificacoes/`, {
			params: body,
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});
		return data;
	} catch (error) {
		return { error };
	}
};

// REQUISITA A LISTA DE OPÇÕES UTILIZADAS NO CABEÇALHO //
export const requestOptionsLists = async (token) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/sinan/notificacoes/opcoes/`,
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);
		return data;
	} catch (error) {
		return { error };
	}
};

// CRIA UMA NOVA NOTIFICAÇÃO //
export const requestSinanCreate = async (body, token) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/sinan/notificacoes/`,
			body,
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);
		return data;
	} catch (error) {
		return { error };
	}
};

// ESTRUTURA DA FICHA //
export const requestSinanStructure = async (token) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/sinan/ficha/dengue_chikungunya_individual/`,
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);
		return data;
	} catch (error) {
		return { error };
	}
};

// AGRAVOS //
export const requestSinanAgravos = async (token) => {
	try {
		const { data } = await axios.get(`${currentUrl}/sinan/agravos/`, {
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});
		return data;
	} catch (error) {
		return { error };
	}
};

// UNIDADES //
export const requestSinanUnidades = async (token) => {
	try {
		const { data } = await axios.get(`${currentUrl}/unidades/`, {
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});
		return data;
	} catch (error) {
		return { error };
	}
};

// BAIRROS //
export const requestSinanBairros = async (token) => {
	try {
		const { data } = await axios.get(`${currentUrl}/catalogos/bairros/`, {
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});
		return data;
	} catch (error) {
		return { error };
	}
};

// CEP POR CÓDIGO //
export const requestSinanCep = async (cep, token) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/catalogos/ceps/${cep}/`,
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);
		return data;
	} catch (error) {
		return { error };
	}
};

// DISTRITOS //
export const requestSinanDistritos = async (token) => {
	try {
		const { data } = await axios.get(`${currentUrl}/catalogos/distritos/`, {
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});
		return data;
	} catch (error) {
		return { error };
	}
};

// RESOLVE CEP //
export const requestSinanResolveCep = async (payload, token) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/catalogos/enderecos/resolve-cep/`,
			payload,
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);
		return data;
	} catch (error) {
		return { error };
	}
};

// MUNICÍPIOS //
export const requestSinanMunicipios = async (token) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/catalogos/municipios/`,
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);
		return data;
	} catch (error) {
		return { error };
	}
};

// LOGRADOUROS POR MUNICÍPIO //
export const requestSinanMunicipioEnderecos = async (token, codigo) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/catalogos/municipios/${codigo}/enderecos/`,
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);
		return data;
	} catch (error) {
		return { error };
	}
};

// REGIÃO DE SAÚDE POR MUNICÍPIO //
export const requestSinanMunicipioRegiaoSaude = async (codigo, token) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/catalogos/municipios/${codigo}/regiao-saude/`,
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);
		return data;
	} catch (error) {
		return { error };
	}
};

// PAÍSES //
export const requestSinanPaises = async (token) => {
	try {
		const { data } = await axios.get(`${currentUrl}/catalogos/paises/`, {
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});
		return data;
	} catch (error) {
		return { error };
	}
};

// REGIÕES DE SAÚDE //
export const requestSinanRegioesSaude = async (token) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/catalogos/regioes-saude/`,
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);
		return data;
	} catch (error) {
		return { error };
	}
};

// UFs //
export const requestSinanUfs = async (token) => {
	try {
		const { data } = await axios.get(`${currentUrl}/catalogos/ufs/`, {
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});
		return data;
	} catch (error) {
		return { error };
	}
};

// ZONAS //
export const requestSinanZonas = async (token) => {
	try {
		const { data } = await axios.get(`${currentUrl}/catalogos/zonas/`, {
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});
		return data;
	} catch (error) {
		return { error };
	}
};
